import React from 'react';
import { DeviceDetailsI, SURFACE_TYPE } from 'src/utils/deviceUtils';
import { DEFAULT_THEME, Theme } from 'src/utils/themeUtils';

export interface SSOConfig {
    assocHandle: string;
    destinationDomain: string;
}

export interface DeviceContextI {
    theme: Theme;
    locale: string;
    device: DeviceDetailsI;
    domain: string;
    isVisible: boolean;
    isFullUrlSupported: boolean;
    isTeenAccount: boolean;
    enableSeeAllDetails: boolean;
    enableAapiCta: boolean;
    enableMes: boolean;
    enableRekindle: boolean;
    enableRekindle2: boolean;
    enableAfrAcquisitions: boolean;
    enableKuUpsell: boolean;
    enableHeartCx: boolean;
    enableReturnBorrowWithSave: boolean;
    enableKuRebrand: boolean;
    bypassAskConsent: boolean;
    debugFlagsTimestamp: number;
    ssoConfig?: SSOConfig;
}

export function getDefaultDeviceContext(): DeviceContextI {
    return {
        theme: DEFAULT_THEME,
        locale: 'en-US',
        device: {
            surfaceType: SURFACE_TYPE.desktop,
            isIOS: false,
            isTablet: false,
            isApp: false,
            isDesktop: false,
        },
        domain: "amazon.com",
        isVisible: false,
        isFullUrlSupported: false,
        isTeenAccount: false,
        enableSeeAllDetails: true,
        enableAapiCta: false,
        enableMes: false,
        enableRekindle: false,
        enableRekindle2: false,
        enableAfrAcquisitions: false,
        enableKuUpsell: false,
        enableHeartCx: false,
        enableReturnBorrowWithSave: false,
        enableKuRebrand: false,
        bypassAskConsent: false,
        debugFlagsTimestamp: 0,
    };
}

const DeviceContext = React.createContext<DeviceContextI>(getDefaultDeviceContext());

export default DeviceContext;
